import React, { ReactElement, useState } from 'react';
import Modal from '@components/Modal';
import UserWorkflowDocumentsSelectorForm from '@/lib/UserWorkflowDocumentsSelectorForm';
import { SelectCompiledDocument } from '@/lib/UserWorkflowDocumentsSelectorForm/UserWorkflowDocumentsSelectorForm';
import * as tsClient from '@tsClient';
import useNoodleApi from '@/hooks/useNoodleApi';
import ProgressIndicator from '@/components/ProgressIndicator';
import Spacer from '@/components/Spacer';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
  creatorId: string;
  userWorkflowId: string;
};

const SelectPetitionPdfDocumentsModal = ({ onClose, onSubmit, creatorId, userWorkflowId }: Props): ReactElement => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { getData: generatePetitionFn } = useNoodleApi(tsClient.workflows.generatePetitionPdf, {
    toastOnError: true,
  });

  const handleSubmit = async (compiledDocuments: SelectCompiledDocument[]): Promise<void> => {
    setIsGenerating(true);
    await generatePetitionFn({
      documents: compiledDocuments,
      userWorkflowId,
    });
    onSubmit();
  };

  return (
    <Modal hasPadding onClose={onClose} title='Prepare ECF Packet'>
      {isGenerating
        ? (
          <>
            <Spacer size={80} />
            <ProgressIndicator isCentered/>
            <Spacer />
            <p className='caption' style={{ color: 'var(--color-gray-75)', textAlign: 'center' }}>
              Compiling Petition.pdf...
            </p>
            <Spacer size={80} />
          </>
        )
        : (
          <UserWorkflowDocumentsSelectorForm
            creatorId={creatorId}
            isForPetitionPdfGeneration={true}
            userWorkflowId={userWorkflowId}
            onSubmit={handleSubmit}
          />
        )}
    </Modal>
  );
};

export default SelectPetitionPdfDocumentsModal;
